"use client";
import { useEffect, useState } from "react";
import { useSession } from "next-auth/react";
import PageLoader from "@/components/pageloader/pageloader";

interface LoaderProps {
  children: React.ReactNode;
}

export function LoaderProvider({ children }: LoaderProps) {
  const { data: session } = useSession();
  const [showLoader, setShowLoader] = useState(true);

  useEffect(() => {
    // Only hide loader if session is resolved (either authenticated or not)
    if (session !== undefined) {
      const timer = setTimeout(() => {
        setShowLoader(false);
      }, 2000);

      return () => clearTimeout(timer);
    }
  }, [session]);

  return showLoader ? <PageLoader initialTip="ProZ.com&trade;" /> : children;
}

export default LoaderProvider;
